export class Border {
  Color: string = '';
  Width?: string;
  Radius?: string;
  Changed: boolean = false;
}
